import type { Translate } from 'next-translate';
import React from 'react';
import { type BenefitItem } from '../../../../../types';
import styles from './ColumnList.module.scss';

interface Props {
	column: BenefitItem[];
	t: Translate;
}
export const ColumnList: React.FC<Props> = ({ column, t }) => {
	return (
		<ul className={`${styles['list']}`}>
			{column.map((item, index) => (
				<li className={`${styles['list__item']}`} key={index}>
					{item.title ? (
						<>
							<h4 className={styles['list__item-title']}>
								<span>{item.icon}</span> <span>{t(item.title)}</span>
							</h4>
							<p className={styles['list__item-subtitle']}>
								{t(item.subtitle)}
							</p>
						</>
					) : (
						<div className={styles['list__item-icon-subtitle']}>
							<span>{item.icon}</span> <p>{t(item.subtitle)}</p>
						</div>
					)}
				</li>
			))}
		</ul>
	);
};
